
export default function RecentBlogItem() {
  return (
    <div className="recent-item mt-3">
      <div className="img">
        <img
          src="https://technext.github.io/energen/images/image_2.jpg"
          alt="1"
        />
      </div>
      <div className="title ms-2">
        <p>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quod eveniet
          ratione earum?
        </p>
      </div>
    </div>
  );
}
